import routeImporter from './routeImporter'
import interceptor from './interceptor'

window.axios = require('axios')

let resources = routeImporter(require.context('./routes', false, /.*\.js$/))
loopResources(resources)
export default resources

function loopResources(resources) {
  for(var r in resources){
    if(_.isFunction(resources[r])) {
      interceptor(resources[r])
    }
    else if(_.isObject(resources[r])){
      loopResources(resources[r])
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/config.js
// module id = null
// module chunks = 